import { render, staticRenderFns } from "./NewShoppingCart.vue?vue&type=template&id=5c7bc259&scoped=true&"
import script from "./NewShoppingCart.vue?vue&type=script&lang=js&"
export * from "./NewShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./NewShoppingCart.vue?vue&type=style&index=0&id=5c7bc259&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7bc259",
  null
  
)

export default component.exports